import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.DeathScreen}-enter {
		.${Layouts.DeathScreen}-background {
			opacity: 0;
		}

		.${Layouts.DeathScreen} {
			opacity: 0;
		}
	}

	&.${Layouts.DeathScreen}-enter-active,
		&.${Layouts.DeathScreen}-enter-done,
		&.${Layouts.DeathScreen}-exit {
		.${Layouts.DeathScreen}-background {
			opacity: 1;
		}

		.${Layouts.DeathScreen} {
			opacity: 1;
		}
	}

	&.${Layouts.DeathScreen}-exit-active {
		.${Layouts.DeathScreen}-background {
			opacity: 0;
		}

		.${Layouts.DeathScreen} {
			opacity: 0;
		}
	}
`;
